import { useTranslation } from 'react-i18next';

import { useModal } from 'Store/modal';

const useConfirmEditModal = () => {
  const { t } = useTranslation('schedule-ruleset');
  const { onOpenModal, onResetModal } = useModal();

  const onOpenConfirmEditModal = (updateRuleset) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'confirm',
      title: t('editConfirmTitle'),
      contentDescription: t('editConfirmDescription'),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('buttonYesSave'),
      secondaryButtonText: t('buttonCancel'),
      onClickPrimaryButton: () => {
        updateRuleset();
        onResetModal();
      },
    });
  };

  return { onOpenConfirmEditModal };
};

export default useConfirmEditModal;
